import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import { Check, LoopRounded } from "@mui/icons-material";
import { Card, CardContent, Typography, CardActions } from "@mui/material";
import "./styles.css";
import { Fade } from "react-reveal";

const roadMap = [
  {
    time: "Sep 2021",
    title: "Esca Token",
    content: "Blockchain Idea",
    extra: "",
    active: false,
    icon: <Check className="icon-timeline" />,
    date: "from 21st March",
    showDate: false,
  },
  {
    time: "January 2022",
    title: "Smart & contract",
    content: "development",
    extra: "",
    active: false,
    icon: <Check className="icon-timeline" />,
    date: "from 21st March",
    showDate: false,
  },
  {
    time: "March 2022",
    title: "Pre-Sale 1",
    content: "750k Tokens at $0.30",
    extra: "",
    active: true,
    icon: <LoopRounded className="icon-timeline" />,
    date: "from 21st March",
    showDate: true,
  },
  {
    time: "March 2022",
    title: "Pre-Sale 2",
    content: "750k Tokens at $0.40",
    extra: "",
    active: false,
    icon: <LoopRounded className="icon-timeline" />,
    date: "24th - 27th March",
    showDate: true,
  },
  {
    time: "April 2022",
    title: "IDO - Final Sale",
    content: "1.5M Tokens at $0.60",
    extra: "",
    active: false,
    icon: <LoopRounded className="icon-timeline" />,
    date: "28th Mar - 1st April",
    showDate: true,
  },
  {
    time: " May 2022",
    title: "Exchange",
    content: "Available for Public",
    extra: "",
    active: false,
    icon: <LoopRounded className="icon-timeline" />,
    date: "from 21st March",
    date: false,
  },
  {
    time: "",
    title: "",
    content: "",
    extra: "",
    active: false,
    icon: <TimelineDot variant="outlined" className="icon-timeline" />,
    date: "",
    date: false,
  },
];
export default function RoadMapTimeline() {
  return (
    <Timeline position="alternate">
      {roadMap.map((item, index) => (
        <TimelineItem>
          <TimelineOppositeContent>{item.time}</TimelineOppositeContent>
          <TimelineSeparator>
            {item.icon}
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent sx={{ py: "12px", px: 2 }}>
            <Fade bottom>
              {" "}
              <Card
                className={
                  item.active
                    ? "active-track"
                    : `${item.title == "" ? "shadow-none" : "normal-card"}`
                }
              >
                <CardContent>
                  <Typography
                    className={
                      !item.active
                        ? "w-100 text-center font-weight-bold"
                        : "w-100 text-center text-white font-weight-bold"
                    }
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    className={
                      !item.active
                        ? "w-100 text-center font-weight-bold"
                        : "w-100 text-center text-white font-weight-bold"
                    }
                  >
                    {item.content}
                  </Typography>
                </CardContent>
                {item.showDate && (
                  <CardActions
                    className={item.active ? `live-track` : `normal-card`}
                  >
                    <Typography
                      className={`w-100 text-center font-weight-bold p-2 ${
                        !item.active ? "text-dark" : "text-white"
                      }`}
                    >
                      {item.date}
                    </Typography>
                  </CardActions>
                )}
              </Card>
            </Fade>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}
